import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface PillTabItem {
  label: string;
  count?: number;
  id?: string;
}

@Component({
  selector: 'app-pill-tabs',
  templateUrl: './pill-tabs.component.html',
  styleUrls: ['./pill-tabs.component.scss'],
})
export class PillTabsComponent {
  @Input() tabs: PillTabItem[] = [];
  @Input() activeIndex = 0;
  @Input() ariaLabel = 'Tabs';
  @Input() columns?: number;

  @Output() activeIndexChange = new EventEmitter<number>();

  get gridColumns(): number {
    return this.columns ?? Math.max(this.tabs.length, 1);
  }

  selectTab(index: number): void {
    if (index === this.activeIndex) {
      return;
    }

    this.activeIndexChange.emit(index);
  }
}
